import type { Filters } from 'corso-admin-ui';

export const isProtected = { isProtected: true } satisfies Filters<'orders'>;
export const notProtected = { isProtected: false } satisfies Filters<'orders'>;
export const online = { isOnline: true } satisfies Filters<'orders'>;
